import { Button, FormControl, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useState } from 'react';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';

const CommonFilterBox = ({
  initialQuery,
  listProvinces = [],
  statusOptions = [],
  onApply,
  onReset,
  isMobile = false,
  hideProvinceFilter = false,
  hideStatusFilter = false
}) => {
  const [query, setQuery] = useState(initialQuery);

  const handleChange = (value, type) => {
    if (type === 'province') {
      setQuery(prev => ({
        ...prev,
        citizen_id: value?.id
      }));
    }

    if (type === 'status') {
      setQuery(prev => ({
        ...prev,
        status: value?.value
      }));
    }
  };

  const handleApply = () => {
    onApply({
      ...query,
      page: 1,
      page_size: isMobile ? 6 : PAGE_SIZE_LIST
    });
  };

  const handleReset = () => {
    const resetQuery = {
      citizen_id: undefined,
      status: undefined,
      page: 1,
      page_size: isMobile ? 6 : PAGE_SIZE_LIST
    };
    setQuery(resetQuery);
    onReset(resetQuery);
  };

  return (
    <div style={{ padding: 16, width: 240 }}>
      <div className="row text-left title-filter mb-3">Bộ lọc</div>

      {!hideProvinceFilter && (
        <FormControl fullWidth size="small" variant="outlined" style={{ marginBottom: 12 }}>
          <Autocomplete
            size="small"
            options={listProvinces}
            getOptionLabel={option => option.name}
            value={
              listProvinces.find(item => item.id === query.citizen_id) || null
            }
            onChange={(e, value) => handleChange(value, 'province')}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Tất cả tỉnh thành"
                InputProps={{
                  ...params.InputProps,
                  readOnly: true
                }}
              />
            )}
          />
        </FormControl>
      )}

      {!hideStatusFilter && (
        <FormControl fullWidth size="small" variant="outlined" style={{ marginBottom: 20 }}>
          <Autocomplete
            size="small"
            options={statusOptions}
            getOptionLabel={option => option.name}
            value={
              statusOptions.find(item => item.value === query.status) || null
            }
            onChange={(e, value) => handleChange(value, 'status')}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Tất cả trạng thái"
                InputProps={{
                  ...params.InputProps,
                  readOnly: true
                }}
              />
            )}
          />
        </FormControl>
      )}
      <div style={{ display: 'flex', gap: 8 }}>
        <Button 
        className="btn-filter btn-plain"
        fullWidth 
        variant="contained" 
        onClick={handleReset}>
          Đặt lại
        </Button>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={handleApply}
        >
          Áp dụng
        </Button>
      </div>
    </div>
  );
};

export default CommonFilterBox;
